import React, { useEffect, useState } from 'react';
import {
  TextField,
  Button,
  Typography,
  Box,
  Autocomplete
} from '@mui/material';
import { fetchHeadings, fetchMaterials, addFormula } from '../../services/materialCalculatorAPI';
import './AddFormula.css';

const AddFormula = () => {
  const [headings, setHeadings] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [selectedHeading, setSelectedHeading] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [baseQuantity, setBaseQuantity] = useState('');
  const [materialQuantity, setMaterialQuantity] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchHeadings()
      .then((data) => {
        const items = Array.isArray(data) ? data : data.headings || [];
        setHeadings(items);
      })
      .catch((err) => console.error("Error fetching headings", err));

    fetchMaterials()
      .then((data) => {
        const items = Array.isArray(data) ? data : data.materials || [];
        setMaterials(items);
      })
      .catch((err) => console.error("Error fetching materials", err));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedHeading || !selectedMaterial || !baseQuantity || !materialQuantity) {
      setMessage("All fields are required");
      return;
    }

    const response = await addFormula({
      heading_id: selectedHeading.id,
      material_id: selectedMaterial.id,
      base_quantity: parseFloat(baseQuantity),
      material_quantity: parseFloat(materialQuantity),
    });

    setMessage(response.message || (response.success ? "Formula added successfully" : "Failed to add formula"));

    if (response.success) {
      setBaseQuantity('');
      setMaterialQuantity('');
      setSelectedHeading(null);
      setSelectedMaterial(null);
    }
  };

  return (
    <div className="add-formula-container">
      <h2 className="formula-title"> Add Formula (Heading ➝ Material)</h2>

      <form onSubmit={handleSubmit} className="formula-form">

        <Autocomplete
          value={selectedHeading}
          onChange={(event, newValue) => setSelectedHeading(newValue)}
          options={headings}
          getOptionLabel={(option) => option ? `${option.name} (${option.unit})` : ''}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField {...params} label="Select Work Heading" className="input-field" required />
          )}
        />

        <Autocomplete
          value={selectedMaterial}
          onChange={(event, newValue) => setSelectedMaterial(newValue)}
          options={materials}
          getOptionLabel={(option) => option ? `${option.name} (${option.unit})` : ''}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          renderInput={(params) => (
            <TextField {...params} label="Select Material" className="input-field" required />
          )}
        />

        <TextField
          type="number"
          step="0.01"
          className="input-field"
          label="Base Quantity (e.g., 13 sqm)"
          value={baseQuantity}
          onChange={(e) => setBaseQuantity(e.target.value)}
          required
        />

        <TextField
          type="number"
          step="0.01"
          className="input-field"
          label="Material Quantity (e.g., 6 studs)"
          value={materialQuantity}
          onChange={(e) => setMaterialQuantity(e.target.value)}
          required
        />

        <Button type="submit" variant="contained" className="submit-button">
          Add Formula
        </Button>

        {message && <Typography className="form-message">{message}</Typography>}
      </form>
    </div>
  );
};

export default AddFormula;
